module.exports = __webpack_public_path__ + "static/media/All_must_join_the_hypno_virus.2fe03448.mp3";